import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reportesdiot',
  templateUrl: './reportesdiot.component.html',
  styleUrls: ['./reportesdiot.component.css']
})
export class ReportesdiotComponent implements OnInit {

  fechaInicio!: string;
  fechaFin!: string;

  reporte: any[] = [];
  columnas: string[] = [];

  totalGeneral: number = 0;

  constructor(private inventarioService: InventarioService) {}

  ngOnInit(): void {}

  calcularTotal() {
    this.totalGeneral = this.reporte.reduce((acc, item) => {
      return acc + (Math.round(Number(item.subtotal)) || 0);
    }, 0);
  }

  consultarFacturasProveedor() { 
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
        icon: 'warning',
        title: 'Selecciona un rango de fechas',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    this.inventarioService.reportePolizasConFacturasTXT({
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin
    }).subscribe({
      next: (res) => {

        if (!res || res.length === 0) {
          this.reporte = [];
          this.columnas = [];

          Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: 'No hay datos en las fechas seleccionadas',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        this.reporte = res;
        this.columnas = Object.keys(res[0]);

        this.calcularTotal();
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al consultar reporte de proveedores'
        });
      }
    });
  }

exportarTXT() {

  if (this.reporte.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'No hay datos para exportar'
    });
    return;
  }

  let contenido = '';

  const agrupados: any = {};

  this.reporte.forEach(r => {

    const tipoTercero = r.tipo_tercero || '04';
    const tipoOperacion = r.tipo_operacion || '85';
    const rfc = (r["R.F.C."] || '').trim();

    const llave = `${tipoTercero}-${tipoOperacion}-${rfc}`;

    if (!agrupados[llave]) {
      agrupados[llave] = {
        tipoTercero,
        tipoOperacion,
        rfc,
        subtotal: 0,
        exento: 0
      };
    }

    agrupados[llave].subtotal += Number(r.subtotal) || 0;
    agrupados[llave].exento += Number(r.exento) || 0;

  });

  Object.values(agrupados).forEach((r: any) => {

    const subtotal = Math.round(r.subtotal || 0);
    const exento = Math.round(r.exento || 0);

    const fila = [

      // 1
      r.tipoTercero,

      // 2
      r.tipoOperacion,

      // 3
      r.rfc,

      // 4-11
      '', '', '', '', '', '', '', '',

      // 12 BASE 16%
      subtotal,

      // 13-48
      ...Array(36).fill(''),

      // 49 EXENTO
      exento,

      // 50
      0,

      // 51-53
      '', '', '',

      // 54
      '01'
    ];

    console.log(
      'RFC:',
      r.rfc,
      'Campos:',
      fila.length
    );

    contenido += fila.join('|') + '\n';

  });

  const blob = new Blob(
    [contenido],
    {
      type: 'text/plain;charset=utf-8;'
    }
  );

  const link = document.createElement('a');

  link.href = URL.createObjectURL(blob);

  link.download = 'reporte_DIOT.txt';

  link.click();

}

}